export const dataLayerEvents = () => {
    const openApplicationFormButtons = document.querySelectorAll(
        '.open-jobapplicationform-button'
    );
    const languageSwitchButton = document.querySelector('#language-switch');
    if (!languageSwitchButton) {
        console.log('languageSwitchButton not found');
    }
    const siteMapLevel3Links = document.querySelectorAll(
        '.sub-menu__level03-link'
    );
    const siteMapLevel2Links = document.querySelectorAll(
        '.sub-menu__level02-link'
    );
    const siteMapLevel1Links = document.querySelectorAll(
        '.sub-menu__level01-link'
    );
    const secondaryLinks = document.querySelectorAll(
        '.sub-menu__secondary-link-link'
    );
    const practicalFooterLinks = document.querySelectorAll('.practical-link');
    const loginLinks = document.querySelectorAll('.login-link');

    if (openApplicationFormButtons[0]) {
        openApplicationFormButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const applicationFormUrl = button.dataset.applicationFormUrl;
                const buttonText = button.dataset.applicationButtonText;

                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    event: 'cta_job_application',
                    cta_text: buttonText,
                });

                window.location = applicationFormUrl;
            });
        });
    }

    if (languageSwitchButton) {
        languageSwitchButton.addEventListener('click', () => {
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
                event: 'language_change',
                selected_language: languageSwitchButton.title,
            });
        });
    }

    if (siteMapLevel3Links[0]) {
        siteMapLevel3Links.forEach((link) => {
            link.addEventListener('click', () => {
                const activeCategory = document.querySelector(
                    '.sub-menu__level01-link--active'
                );

                window.dataLayer = window.dataLayer || [];

                var linkObject = {
                    event: 'menu_navigation',
                    type: 'Sitemap menu',
                    nav_subitem: link.textContent.trim(),
                    nav_item:
                        link.parentElement.parentElement.parentElement.previousElementSibling.textContent.trim(),
                    nav_category: activeCategory.textContent.trim(),
                };

                window.dataLayer.push(linkObject);
            });
        });
    }

    if (siteMapLevel2Links[0]) {
        siteMapLevel2Links.forEach((link) => {
            link.addEventListener('click', () => {
                const activeCategory = document.querySelector(
                    '.sub-menu__level01-link--active'
                );

                window.dataLayer = window.dataLayer || [];

                var linkObject = {
                    event: 'menu_navigation',
                    type: 'Sitemap menu',
                    nav_item: link.textContent.trim(),
                    nav_category: activeCategory.textContent.trim(),
                };

                window.dataLayer.push(linkObject);
                //console.log(linkObject);
            });
        });
    }

    if (siteMapLevel1Links[0]) {
        siteMapLevel1Links.forEach((link) => {
            link.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];

                var linkObject = {
                    event: 'menu_navigation',
                    type: 'Sitemap menu',
                    nav_category: link.textContent.trim(),
                };

                window.dataLayer.push(linkObject);

                //console.log(linkObject);
            });
        });
    }

    if (secondaryLinks[0]) {
        secondaryLinks.forEach((link) => {
            link.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];

                var linkObject = {
                    event: 'menu_navigation',
                    type: 'Sitemap menu',
                    nav_item: link.textContent.trim(),
                };

                window.dataLayer.push(linkObject);
                //console.log(linkObject);
            });
        });
    }

    if (practicalFooterLinks[0]) {
        practicalFooterLinks.forEach((link) => {
            const linkText = link.textContent.trim();

            if (
                linkText.toLowerCase().includes('newsletter') ||
                linkText.toLowerCase().includes('nieuwsbrie')
            ) {
                link.addEventListener('click', () => {
                    window.dataLayer = window.dataLayer || [];

                    var linkObject = {
                        event: 'newsletter_clickout',
                    };

                    window.dataLayer.push(linkObject);
                    //console.log(linkObject);
                });
            }
        });
    }

    if (loginLinks[0]) {
        loginLinks.forEach((button) => {
            button.addEventListener('click', () => {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    event: 'navigation_to_my_LUMC',
                });
            });
        });
    }
};
